import { IconButton, ListItem, Stack } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function MacroGuidanceListItem({ macro, selectedId, onOpen, actionIcon = "mdi:chevron-right" }) {
    if (!macro) return null
    const active = macro?.id === selectedId
    const canOpen = typeof onOpen === "function"
    const isComponent = macro?.id?.startsWith("cmp:")
    const isBroken = !!macro?.broken
    return (
        <ListItem
            sx={{
                px: 1,
                py: 0.75,
                borderRadius: 1,
                border: "1px solid",
                borderColor: isBroken ? "error.light" : active ? "primary.main" : "primary.light",
                bgcolor: isBroken ? "error.lighter" : active ? "primary.light" : "primary.lighter",
            }}
            disableGutters
        >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ width: 1, minWidth: 0 }}>
                <If truthy={isComponent || isBroken}>
                    <Iconify
                        icon={isBroken ? "mdi:alert-circle-outline" : "mdi:puzzle-outline"}
                        sx={{ color: isBroken ? "error.main" : "secondary.main", flexShrink: 0, fontSize: 18 }}
                    />
                </If>
                <Stack
                    spacing={0.5}
                    sx={{ width: 1, minWidth: 0, cursor: canOpen ? "pointer" : "default" }}
                    onClick={canOpen ? handleOpen : undefined}
                    data-cy="macro-guidance-open"
                >
                    <TruncatedTypography
                        variant="subtitle2"
                        sx={{
                            lineHeight: 1.2,
                            color: isBroken ? "error.dark" : active ? "primary.dark" : "text.primary",
                        }}
                    >
                        {macro.label ?? macro.name ?? "Macro"}
                    </TruncatedTypography>
                </Stack>
                <If truthy={canOpen}>
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={handleOpen}
                        data-cy={`macro-guidance-open-${macro.id}`}
                        aria-label="View macro"
                    >
                        <Iconify icon={actionIcon} />
                    </IconButton>
                </If>
            </Stack>
        </ListItem>
    )

    function handleOpen(event) {
        event.stopPropagation()
        onOpen(macro.id)
    }
}
